import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  inject,
  OnInit,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { shareShoutoutLink } from 'src/app/helpers/shareShoutoutLink';
import { ShoutoutsStoreService } from 'src/app/services/stores/shoutouts.store.service';
import { EventStoreService } from 'src/app/services/stores/event.store.service';

@Component({
  selector: 'app-event-wall',
  templateUrl: './event-wall.component.html',
  styleUrls: ['./event-wall.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  providers: [EventStoreService, ShoutoutsStoreService],
})
export class EventWallComponent implements OnInit {
  private _route: ActivatedRoute = inject(ActivatedRoute);
  protected eventStoreService: EventStoreService = inject(EventStoreService);
  protected shoutoutsStoreService: ShoutoutsStoreService = inject(
    ShoutoutsStoreService,
  );
  eventId: WritableSignal<string | null> = signal(null);
  sessionId: WritableSignal<string | null> = signal(null);
  rotationIntervalSec: WritableSignal<number> = signal(15); // in seconds
  rotationIndex: WritableSignal<number> = signal(0);
  rotationLength: WritableSignal<number> = signal(0);
  qrWidth: WritableSignal<number> = signal(250);
  qrWidthRatio: WritableSignal<number> = signal(0.6);
  shoutoutRotationInterval$: Subscription;
  @ViewChild('shoutoutWall', { static: true }) shoutoutWall!: ElementRef;

  constructor() {
    effect(() => {
      this.shoutoutsStoreService.get(
        this.eventId()!,
        this.sessionId(),
        true,
        true,
        true,
        true,
        'createdAt',
        'asc',
      );
    });
    this.shoutoutRotationInterval$ = interval(
      this.rotationIntervalSec() * 1000,
    ).subscribe(this.rotateShoutouts.bind(this));
  }

  ngOnInit(): void {
    this.qrWidth.set(window.innerHeight * this.qrWidthRatio());
    this.eventId.set(this._route.snapshot.paramMap.get('eventId'));
    this.eventStoreService.getById(this.eventId()!);
  }

  ngOnDestroy() {
    this.shoutoutRotationInterval$.unsubscribe();
  }

  rotateShoutouts() {
    this.rotationIndex.set(this.rotationIndex() + 1);
    if (this.rotationIndex === this.rotationLength) {
      this.qrWidth.set(window.innerHeight * this.qrWidthRatio());
    }
    if (this.rotationIndex > this.rotationLength) {
      this.rotationIndex.set(0);
    }
  }

  showFullscreen() {
    this.shoutoutWall.nativeElement.requestFullscreen();
  }

  shareLink(): string {
    return shareShoutoutLink(this.eventStoreService.event()?.id || null);
  }
}
